"use client";

import { Stencil } from "components/Stencil";
import { Container } from "ct-design";

const CouponLoader = () => {
  return (
    <Container className="flex ">
      <Stencil height={60} width={260} className="flex-1 br-12" />
      <Stencil height={60} width={260} className="flex-1 ml-6 mr-6 br-12" />
      <Stencil height={60} width={260} className="flex-1 br-12" />
    </Container>
  );
};
export default CouponLoader;
